<template>
    <div class="list-users-page">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Manage applications</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <!--
                        <div class="border-0 card-header">
                            <h3 class="mb-0">Light table</h3>
                        </div>
                        -->
                        <div class="card-body">
                            <base-button
                                type="primary"
                                class="mb-4"
                                @click="openApplicationEditor()">
                                <i class="ai ai-plus"></i>
                                Add new application
                            </base-button>

                            <el-popover
                                placement="left"
                                title="Filter applications"
                                class="float-right"
                                popper-class="users-table-filter"
                                width="350"
                                trigger="click">
                                <base-button slot="reference" type="primary" outline class="filter-btn">
                                    <i class="m-0 ai ai-filter"></i>
                                    <i class="m-0 ai ai-angle-down"></i>
                                </base-button>
                                <el-form :model="filter" label-width="100px">
                                    <el-form-item label="Name">
                                        <el-input v-model="filter.name"></el-input>
                                    </el-form-item>
                                </el-form>
                            </el-popover>

                            <el-table
                                border
                                class="table-responsive table-flush"
                                header-row-class-name="thead-light"
                                :data="filteredData"
                                :empty-text="isLoadingTableData ? 'Loading...' : 'No Data'"
                                lazy>

                                <el-table-column label="ID" prop="id" width="100" sortable></el-table-column>
                                <el-table-column label="Name" prop="name" sortable></el-table-column>
                                <el-table-column label="Url" prop="url" sortable></el-table-column>
                                <el-table-column label="Created at" prop="created_at" sortable></el-table-column>

                                <el-table-column label="actions" class-name="actions-column" width="130px">
                                    <template v-slot="{row}">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Edit hotel group"
                                            placement="top">
                                            <button
                                                type="button"
                                                @click="openApplicationEditor(row)"><i class="ai ai-edit text-yellow"></i>
                                            </button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Delete hotel group"
                                            placement="top">
                                            <button type="button" @click="deleteApplicationAttention(row)">
                                                <i class="ai ai-remove text-danger"></i>
                                            </button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <!--
                            <div class="card-footer py-4 d-flex justify-content-center">
                                <base-pagination v-model="currentPage"
                                                 :total="pageCount * itemsPerPage"></base-pagination>
                            </div>
                            -->
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <el-dialog
            title="Warning"
            :visible.sync="showDeleteApplicationAttentionModal"
            width="550px"
            center>
            <div class="h2 text-center">
                Are you sure you want to delete this application: {{ selectedAppForDelete.name }}?
            </div>
            <div slot="footer" class="dialog-footer">
                <base-button
                    outline
                    type="secondary"
                    @click="showDeleteApplicationAttentionModal = false">Cancel
                </base-button>
                <base-button type="danger" @click="deleteHotelGroup">Delete</base-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="selectedApp.id ? 'Edit application' : 'Add new application'"
            :visible.sync="showApplicationEditorModal"
            width="550px"
            center
            @closed="closeApplicationEditor">
            <el-form>
                <base-input
                    label="Application name"
                    type="text"
                    v-model="selectedApp.name">
                </base-input>
                <base-input
                    label="Application URL"
                    type="text"
                    v-model="selectedApp.url">
                </base-input>
                <base-input
                    label="Application logo URL"
                    type="text"
                    v-model="selectedApp.logo_url">
                </base-input>
                <div class="user-form-group">
                    <label>Available permissions</label>
                    <el-checkbox-group v-model="availablePermissions">
                        <el-checkbox
                            v-for="(perm, idx) in permissions"
                            :key="idx"
                            :label="perm"></el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <base-button outline type="danger" @click="closeApplicationEditor">Cancel</base-button>
                <base-button
                    type="success"
                    :disabled="!applicationCanBeSave"
                    @click="saveApplication">
                    <i class="ai ai-save"></i>
                    {{ selectedApp.id ? 'Save' : 'Add' }}
                </base-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import {BaseProgress} from '@/components'
    import RandomBackgroundColor from '@/mixins/random-background-color'
    import DeleteUserMixin from '@/mixins/delete-user'
    import {
        Table,
        TableColumn,
        DropdownMenu,
        DropdownItem,
        Dropdown,
        Pagination,
        Form,
        FormItem,
        Select,
        Option,
        Dialog,
        CheckboxGroup,
        Checkbox,
    } from 'element-ui'

    export default {
        name: 'user-list',
        mixins: [RandomBackgroundColor, DeleteUserMixin],
        components: {
            BaseProgress,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Pagination.name]: Pagination,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Select.name]: Select,
            [Option.name]: Option,
            [Dialog.name]: Dialog,
            [CheckboxGroup.name]: CheckboxGroup,
            [Checkbox.name]: Checkbox,
        },
        data() {
            return {
                applications: [],
                // currentPage: 0,
                // itemsPerPage: 10,
                // pageCount: 0,
                isLoadingTableData: true,
                showDeleteApplicationAttentionModal: false,
                showApplicationEditorModal: false,
                selectedApp: {},
                selectedAppForDelete: {},
                availablePermissions: [],
                permissions: ['upload', 'view', 'edit', 'admin'],
                filter: {
                    name: null,
                },
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser'
            }),
            filteredData: {
                get() {
                    const keys = Object.keys(this.filter);
                    let filteredData = [...this.applications];
                    console.log('FILTER', this.filter);

                    // Filter by name
                    if (this.filter.name) {
                        filteredData = filteredData.filter(hg => hg.name.toLowerCase().includes(this.filter.name.toLowerCase()));
                    }

                    // this.pageCount = Math.ceil(filteredHotelGroups.length / this.itemsPerPage) || 1;

                    /* Pagination START */
                    // const from = (this.currentPage - 1) * this.itemsPerPage;
                    // const to = from + this.itemsPerPage;
                    // filteredHotelGroups = filteredHotelGroups.slice(from, to);
                    /* Pagination END */

                    console.log('FFF', filteredData)
                    return filteredData;
                }
            },
            applicationCanBeSave() {
                return this.selectedApp.name && this.selectedApp.url;
            }
        },
        methods: {
            deleteApplicationAttention(hotelGroup) {
                this.showDeleteApplicationAttentionModal = true;
                this.selectedAppForDelete = hotelGroup;
            },
            deleteHotelGroup() {
                this.$axios.delete('/api/applications/' + this.selectedAppForDelete.id)
                    .then(res => {
                        this.applications = this.applications.filter(user => user.id !== this.selectedAppForDelete.id)
                        this.$notify({
                            title: 'Application removed',
                        });
                    })
                    .catch(({response}) => {
                        this.$notify({
                            title: response.data.message,
                            type: 'danger',
                        });
                    })
                    .then(() => {
                        this.showDeleteApplicationAttentionModal = false;
                        this.selectedUserForDelete = {};
                    })
            },
            openApplicationEditor(hotelGroup) {
                this.showApplicationEditorModal = true;
                this.availablePermissions = hotelGroup ? hotelGroup.available_permissions : [];
                this.selectedApp = JSON.parse(JSON.stringify(hotelGroup || {available_permissions: []}));
            },
            closeApplicationEditor() {
                this.showApplicationEditorModal = false;
                this.selectedApp = {};
                this.availablePermissions = [];
            },
            saveApplication() {
                this.selectedApp.available_permissions = this.availablePermissions;

                if (this.selectedApp.id) {
                    this.$axios.put('/api/applications/' + this.selectedApp.id, this.selectedApp)
                        .then(res => {
                            const app = res.data.item;
                            const appIdx = this.applications.findIndex(hg => hg.id === app.id);
                            this.applications[appIdx] = app;
                            this.applications = [...this.applications];
                            this.$notify({
                                title: 'Application has updated',
                            });
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                        .then(() => {
                            this.closeApplicationEditor();
                        })
                } else {
                    this.$axios.post('/api/applications', this.selectedApp)
                        .then(res => {
                            const app = res.data.item;
                            this.applications.push(app);
                            this.$notify({
                                title: 'New application has added',
                            });
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                        .then(() => {
                            this.closeApplicationEditor();
                        })

                }
            },
        },
        async created() {
            this.applications = (await this.$axios.get('/api/admin/applications')).data.data;
            console.log('CREATED', this.applications);

            this.isLoadingTableData = false;
        },
    };
</script>
<style lang="scss">
    .list-users-page {
        .application-icon {
            display: inline-block;
            width: 36px;
            height: 36px;
            object-fit: cover;
            object-position: center center;
            cursor: default;

            &:not(:last-child) {
                margin-right: 5px;
            }

            &.text-icon {
                color: #fff;
                text-transform: uppercase;
                text-align: center;
                border-radius: 500px;
                line-height: 36px;
                font-size: 24px;
                vertical-align: middle;
            }
        }
    }

    .users-table-filter {
        .el-select {
            width: 100%;
        }
    }
</style>
